import { render, staticRenderFns } from "./ProductAdditionalFields.vue?vue&type=template&id=ab87b23e&scoped=true&lang=pug&"
import script from "./ProductAdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./ProductAdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAdditionalFields.vue?vue&type=style&index=0&id=ab87b23e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab87b23e",
  null
  
)

export default component.exports